<template>


  <div :class="{room: true, worked: worked}" v-if="props.room">
     
    <div class="title">

      <ChatV2Close
        @close="close"
        />
        
      
      <NuxtLink 
        v-if="!props.room.is_group"
        :to="'/grower/' + props.room.name" 
        :class="{'name': true}" @click="close();emits('closeChat')">
        <img loading="lazy" class="avatar" :src="props.room.avatar">
        <span>{{ props.room.name }}</span>
        <div v-if="props.room.is_online" class="online" title="online"></div>
      </NuxtLink>
      
      <div 
        v-else
        class="name">
        <span>{{ props.room.name ?? 'New group' }}</span>  
      </div>
      
      <!-- <div class="btn_close" @click="close"><i class="icon-remove"></i></div> -->
 
      <div class="options" v-if="useAuth().isAuth() && useAuth().isVerifiedEmail()">
                
        <!-- <i class="icon-dots" @click="handleOptions"></i> -->


        <UiButtonDropdown
          :ico="'icon-dots'"
          :options="actionsRoom"
          @choose="handleAction"
          />
 
        
<!-- 
        <div class="remove" @click="remove"><i class="icon-trash"></i> Remove chat</div>
        <template v-if="props.room.is_admin">
          <div v-if="props.room.is_group" class="manage" @click="$emit('manage')"><i class="icon-setting"></i> Manage group</div>
          <div v-if="props.room.is_group" class="manage" @click="$emit('invite')"><i class="icon-users"></i> Invite users</div>
        </template>
        <template v-else>
          <div class="warning" @click="complain"><i class="icon-warning"></i> Complain</div>
          <div class="ban" @click="ban"><i class="icon-ban"></i> Ignore</div>
        </template> -->
        
      </div>
    </div>

    <!-- {{ preloadLast }} -->

    <div class="messages" ref="el_messages">
      <div class="messages_items">

        <!-- Показываем скелетон при первоначальной загрузке -->
        <template v-if="isInitialLoading">
          <SkChatMessages />
        </template>

        <!-- Показываем сообщения после загрузки -->
        <template v-else>
          <template
            v-for="(opt, opt_key) in messages"
            >

            <div :class="'message_item' + (useAuth().getId() == opt.user_id || opt.guest_id ? ' is_my ' : '')">

              <div class="text">
                <NuxtLink 
                  v-if="props.room?.is_group && !opt.is_my"
                  :to="'/grower/' + opt.user_name" class="user-name">
                  {{ opt.user_name }}
                </NuxtLink>
                <div v-html="formatChatMessageText(opt.text, opt)"></div>
              </div>      

            </div>
            
          </template>

          <!-- {{ isEnded   }} -->

          <ClientOnly>
            <UiInfinityScroll 
              v-show="!isEnded"
              :is-loading="isLoading"
              ref="elInfinityScroll"/>
          </ClientOnly>
        </template>
        
      </div>
    </div>


    <ChatV2Form
      :room="props.room"
      :allowed-message-send="allowedMessageSend"
      @message-sent="handleMessageSent"
    />
  </div>
  
</template>


<script setup lang="ts">

import { formatChatMessageText } from '@/types/other';
import { useIntersectionObserver } from '@vueuse/core'
import { NotificationChannel } from '@/types/notification'

const { $dayjs, $api, $observer, $ga } = useNuxtApp();
const emits = defineEmits(['closeRoom', 'closeChat', 'complain', 'ban', 'remove', 'manage', 'invite'])
const props = defineProps({
  room: {
    type: Object
  },
  worked: {
    type: Boolean
  },
})
const el_messages = ref(null);
const elInfinityScroll = ref(null);


const limit = ref(20);
const opened = ref(false);
const messages = ref<any[]>([]);
// const preload = ref(null);
// const preloadFirst = ref(null);
// const preloadLast = ref(null);
const lastLoadedCount = ref(0);
const isEnded = ref(false);
const isLoading = ref(false);
const isInitialLoading = ref(true);
const timerLoadMessages = ref(null);


const close = () => {
  opened.value = false;
  clear();
  emits('closeRoom');
}

const isReadyLoadingMessages = computed(() => {
  if(import.meta.client){
    return document.visibilityState === 'visible';
  }
  return false;
})

const checkVisibility = () => {
  if(import.meta.client){
    console.log('checkVisibility', document.visibilityState);
    console.log('checkVisibility', document.hidden);
    return document.visibilityState === 'visible';
  }
  return false;
}

 

const actionsRoom = computed(() => {
  var actions = [];

  actions.push({
    name: 'Remove chat',
    event: 'remove'
  });

  if(props.room?.is_admin && props.room?.is_group) {
    actions.push({
      name: 'Manage group',
      event: 'manage'
    });

    actions.push({
      name: 'Invite users',
      event: 'invite'
    });
  }else{

    actions.push({
      name: 'Complain',
      event: 'complain'
    });

    actions.push({
      name: 'Ignore',
      event: 'ban'
    });
  }
 
 

  return actions;
});

const handleAction = (action: string) => {
  switch(action) {
    case 'remove':
      remove();
      break;
    case 'manage':
      emits('manage');
      break;
    case 'invite':
      emits('invite');
      break;
    case 'complain':
      complain();
      break;
    case 'ban':
      ban();
      break;
  }
}



const allowedMessageSend = computed(() => {

  if(useAuth().isAuth()){
    if(!useAuth().isVerifiedEmail() && !props.room.allowed_guest){
      return false;
    }
  }else{
    if(!props.room.allowed_guest){
      return false;
    }
  }
  return true;
})
 


const time = function(vl: number){
  var today = new Date(vl*1000);
  var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
  var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
  var dateTime = date + ' ' + time;
  return $dayjs(dateTime).utc().fromNow();
}


const handleMessageSent = (messageData: any) => {
  messages.value.unshift(messageData);
}





const clear = function(){
  messages.value = [];
  isEnded.value = false;
  isLoading.value = false;
  isInitialLoading.value = true;
}

const complain = function(){       
  $api.postMessagesRoomCompain(props.room.id).then((res) => {                               
    clear();
    emits('complain');
    $ga.eventGA('user_complain');
  });     
}

const ban = function(){       
  $api.postMessagesRoomBan(props.room.id).then((res) => {                               
    clear();
    emits('ban');
  });     
}

const remove = async function(){    

  if(!(await useUiModalConfirm().confirm('Remove chat?')))
        return;
        
  let toastId = useToast().progress('Removing chat...');

  try {

    await $api.deleteMessagesRoom(props.room.id).then((res) => {                               
      clear();
      emits('remove');
    });

    useToast().successProgress(toastId, 'Chat removed');
    
  } catch (error) {

    useToast().errorProgress(toastId, 'Error');
    
  }



}

const preloadFirst = computed(() => {
  return messages.value[0]?.id;
})
const preloadLast = computed(() => {
  
  return messages.value[messages.value.length - 1]?.id;
})

const fillFirstLast = function(){
  if(messages.value.length == 0) return false;
  // preloadFirst.value = messages.value[messages.value.length - 1].id;
  // preloadLast.value = messages.value[0].id;
}

const loadChatMessages = async function(){
  if(!checkVisibility()) return false;
  if(isLoading.value) return false;
  if(!props.room) return false;
  
  try {
    var data = await $api.getMessagesRoomMessages(
        props.room.id, 
        preloadFirst.value, 
        preloadLast.value, 
        0, 
        0,
    )
    if(data?.length == 0) {
      isEnded.value = true;
      return;
    }
    lastLoadedCount.value = data?.length ?? 0;
    actualNotificationsNumbers(data)
    messages.value.unshift(...data.reverse());   
    makeUnreadMessagesRead()
    fillFirstLast();
  } finally {
    // Скрываем скелетон после первой загрузки
    isInitialLoading.value = false;
  }
}

const actualNotificationsNumbers = (data: any[]) => {
  if(!props.room) return false;
  if(!data) return false;
  if(data?.find(item => item.is_new)){
    useNotifications().updateUnreadCount(NotificationChannel.Messages, -1 * data.filter(item => item.is_new).length)
  }
}

const makeUnreadMessagesRead = () => {
  messages.value.forEach((item: any) => {
    item.is_new = false
  })
}
 

const preloadMessages = async function(){
  if(!props.room || isLoading.value || isEnded.value || messages.value.length == 0) 
    return false;
  
  isLoading.value = true;
  
  try {
    var data = await $api.getMessagesRoomMessages(
      props.room.id, 
      0, 
      preloadLast.value, 
      1, 
      0,
    )

    lastLoadedCount.value = data?.length ?? 0;
    
    if(data?.length === 0) {
      isEnded.value = true;
      return;
    }
    
    // Для старых сообщений добавляем их в конец массива (они будут показаны сверху из-за column-reverse)
    messages.value.push(...data.reverse());
    fillFirstLast();
  } finally {
    isLoading.value = false;
  }
}


watch(() => props.room?.id, (newId, oldId) => {
  if (newId !== oldId) {
    clear();
    loadChatMessages();
  }
}, { deep: true })

// watchArray([props.room.id], async ([new_room], added, removed) => {
//   console.log(props.room);
//   loadChatMessages();
//   scrollToEnd();
// }, {deep: true})

clear();
loadChatMessages();

// Intersection Observer для автоматической подгрузки старых сообщений
useIntersectionObserver(
  elInfinityScroll,
  ([{isIntersecting}]) => {
    if(isIntersecting && !isEnded.value && !isLoading.value){
      console.log('infinity scroll event - loading older messages');        
      preloadMessages();
    }
  },
  { }
);
 




onMounted(() => {
 

  if(timerLoadMessages.value) {
    clearInterval(timerLoadMessages.value);
  }
  
  timerLoadMessages.value = setInterval(loadChatMessages, 5000);

})

onBeforeUnmount(() => {
  clear();
  if(timerLoadMessages.value) {
    clearInterval(timerLoadMessages.value);
  } 
})

</script>
 


<style scoped>
  

/* ROOM */
.room {
  display: inline-block;
  width: 100%;
  height: 50px;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.is-page .room {
  height: calc(100dvh - 175px);
}


.room>.title {
  display: flex;
  align-items: center;
  position: relative;
  flex-shrink: 0;
  /* position: sticky; */
  /* top: 0; */
  background-color: var(--un-background-color-gray-light);
  /* z-index: 1001; */
}

.room>.title>.options{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-right: 0.5rem;
}
.room>.title>.options :deep(.btn){
  background-color: transparent!important;

  padding: 0;
}
.room>.title>.options :deep(.btn .ched){
  display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 60px;
    height: 40px;
    font-size: 1.2rem;
    cursor: pointer;
    padding-right: 0.5rem;

} 
.room>.title>.options>.warning,
.room>.title>.options>.remove,
.room>.title>.options>.leave,
.room>.title>.options>.manage,
.room>.title>.options>.ban {
  font-size: 0.75rem;
  color: gray;
  cursor: pointer;
  display: inline-block;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.room>.title>.options>.manage:hover {
  color: var(--un-text-color);
}

.room>.title>.options>.warning:hover .room>.title>.options>.leave:hover,
.room>.title>.options>.ban:hover {
  color: red;
}

.room>.title>.options>.remove:hover {
  color: var(--un-firm);
}

 
.room>.title .avatar {
  width: 25px;
  border-radius: 30px;
  vertical-align: middle;
  margin-right: 10px;
} 
.room>.title .name {
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  /* margin-right: auto; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
  
  width: auto;
    margin: 0 auto;
}
.room>.title .name span{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.room>.title .btn_close {
  display: inline-block;
  position: absolute;
  right: 6px;
  top: 15px;
  cursor: pointer;
  font-size: 0.8rem;
}

 

/* MESSAGES */
.room>.messages {
  padding: 20px;
  overflow-y: auto;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  /* margin-bottom: 40px; */
}
.is-page .room>.messages {
  height: 100%;
}
.room>.messages .messages_items {
  display: flex;
  flex-direction: column-reverse;
}
/* .is-page .room>.messages .messages_items {
  min-height: calc(100vh - 340px);
} */

.room>.messages .preload,
.room>.messages .user_typing {
  text-align: center;
  color: var(--gd-link-hover-color);
  margin-bottom: 1rem;
  cursor: pointer;
}

.room>.messages .message_item {
  margin-bottom: 3px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
}

.room>.messages .avatar {
  display: inline-block;
  vertical-align: top;
  margin-right: 16px;
}

.room>.messages .avatar.same {
  opacity: 0;
}
.room>.messages .avatar_img {
  width: 40px;
  border-radius: 30px;
}

.room>.messages .text {
  display: inline-block;
  background-color: var(--un-background-color-gray);
  padding: 6px 15px;
  position: relative;
  max-width: calc(100% - 90px);
  word-wrap: break-word;
  border-radius: 15px 15px 15px 5px;
}
.room>.messages .text .user-name{
  font-weight: bold;
  font-size: 0.75rem;
}
.room>.messages .text:before {
  content: "\A";
  border-style: solid;
  border-width: 10px 10px 0px 0;

  border-radius: 4px;
  border-color: transparent var(--un-background-color-gray) transparent transparent;
  position: absolute;
  left: -8px;
  bottom: 0px;
}
.room>.messages .text :deep(.dt){
  font-size: 0.65rem;
  color: gray;
  opacity: 0.7;
  margin-left: 0.5rem;
}
.room>.messages .text :deep(.dt.is-nl){
  display: block;
  width: 100%;
  text-align: right;

  margin-left: 0;
}

.room>.messages .message_item .user_name {
  display: inline-block;
  min-width: 40px;
  text-align: center;
  color: var(--un-text-color);
}

.room>.messages .message_item .user_name:hover {
  color: black;
}

.room>.messages .message_item .time {
  display: inline-block;
  margin-right: 13px;
  margin-left: 13px;
  color: transparent;
}

.room>.messages .message_item:hover .time {
  color: #a0a0a0;
}

.room>.messages .message_item .bot {
  text-align: left;
  font-size: 0.75rem;
  color: var(--un-text-color);
    width: 100%;
    display: flex;
}

.room>.messages .message_item.is_my .bot {
  text-align: right;
    flex-direction: row-reverse;
}

.room>.messages .message_item.is_my {
  text-align: right;
  justify-content: flex-end;
  flex-direction: row-reverse;
}

.room>.messages .message_item.is_my .avatar {
  margin-right: 0px;
}

.room>.messages .message_item.is_my .text {
  margin-right: 0px;
  word-wrap: break-word;
  margin-left: auto;
  white-space: pre-wrap;
  background-color: var(--gd-chat-message-background-color);
  border-radius: 15px 15px 5px 15px;
}

.room>.messages .message_item .text.is_new {
  background-color: #edf9e6;
  color: #494949;
}

.room>.messages .message_item.is_my .text:before {
  /* right: -10px; */
  /* border-width: 10px 0px 10px 20px; */
  /* border-color: transparent rgb(247, 247, 247) transparent transparent; */
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 0 0px 10px;
  border-radius: 4px;
  border-color: transparent transparent transparent var(--gd-chat-message-background-color);
  left: calc(100% - 3px);
}
  


@media (min-width: 768px) {
  .room {
    display: none;
  }

  .room.worked {
    display: flex;
  }
}

</style>